import APIClient from '@/shared/http/clients/api'

const resourceName = 'metas'
const APICore = process.env.APIBaseURLCore

const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, config)
const GetByUserId = (id, index, limit, config = {}) => APIClient.get(`${APICore}/${resourceName}/usuario/${id}/produtos/?page=${index}&size=${limit}`, config)
const GetKPIByUserId = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/usuario/${id}/produtos-kpi`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const CreateProduct = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/produtos/`, data, config)
const ChangeStatusProduct = (id, data = {}, config = {}) => APIClient.patch(`${APICore}/${resourceName}/produtos/${id}/`, data, config)
const ChangePeriodicity = (id, data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/periodo/${id}/`, data, config)
const UpdateProduct = (id, data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/produtos/${id}/`, data, config)
const ChangeStatus = (id, data = {}, config = {}) => APIClient.patch(`${APICore}/${resourceName}/${id}/`, data, config)

const GoalRepository = {
  GetAllPaging,
  GetByUserId,
  Create,
  UpdateProduct,
  CreateProduct,
  ChangeStatusProduct,
  ChangePeriodicity,
  ChangeStatus,
  GetKPIByUserId
}

export default GoalRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/metas/metas.js